export const classes = {
  bannerContainer: {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media screen and (max-width: 375px)': {
      minHeight: '180px',
      background: 'black',
    },
  },
  btnSlide: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    '&:focus': {
      outline: 'none',
    }
  },
  prev: {
    width: '26px',
    height: '24px',
    position: 'relative',
    background: '#D91B5B 0% 0% no-repeat',
    boxShadow: '0px 3px 6px #00000029',
    borderRadius: '4px',
    borderColor: 'transparent',
    opacity: 1,
  },
  next: {
    width: '26px',
    height: '24px',
    position: 'relative',
    background: '#D91B5B 0% 0% no-repeat',
    boxShadow: '0px 3px 6px #00000029',
    borderRadius: '4px',
    borderColor: 'transparent',
    opacity: 1,
  },
  containerDots: {
    position: 'relative',
    display: 'flex',
    top: '-32px',
    alignItems: 'center',
    '@media screen and (max-width: 599px)': {
			marginBottom: '16px',
      top: '16px',
		},
  },
  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '4px',
    margin: '0 5px',
    background: '#C3C3C3 0% 0% no-repeat padding-box',
  },
  dotActive: {
    background: '#D91B5B !important',
  }
};
